import React from 'react'
import {IconButton, Button, useDisclosure, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, useToast } from '@chakra-ui/react'
import { DeleteIcon } from '@chakra-ui/icons'
import { UserAPI } from 'apis/UserAPI'

export const DeleteButton = ({_id, updateUserList, name}) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const cancelRef = React.useRef()
    const toast = useToast()

    const deleteUser = () => {
        UserAPI.delete(_id).then(resp => {
            if(resp.status === 0) {
                updateUserList()
                toast({
                    title: 'User deleted',
                    description: `${name} has been successfully deleted.`,
                    status: 'success',
                    duration: 5000,
                    isClosable: true,
                })
            }
            onClose()
        }).catch(err => {
            toast({
                title: 'Error deleting user',
                description: `Failed to delete ${name}. Please try again later.`,
                status: 'error',
                duration: 5000,
                isClosable: true,
            })
            console.error(err)
        })
    }

    return (
        <>
            <IconButton
                colorScheme='red' 
                aria-label='Delete User'
                icon={<DeleteIcon/>}
                size='sm' 
                onClick={onOpen}>
                    Delete
            </IconButton>
            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            Delete User
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            Are you sure you want to delete { name }? This action cannot be undone.
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Cancel
                            </Button>
                            <Button colorScheme='red' onClick={deleteUser} ml={3}>
                                Delete
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}